import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db } from "../../firebase";

const getOwnerNameForBusiness = async (uid) => {
  try {
    // const UserCollection = doc(db, "users");

    // let q = query(UserCollection);

    const UsersSnapshot = await getDoc(doc(db, "users", uid));
    let name = "";

    name = UsersSnapshot.data().name;

    return name ?? "";
  } catch (error) {
    console.log(error);
    return "";
  }
};

export default getOwnerNameForBusiness;
